import { IChapterList, IKeyframeItem } from '@/types/summary';
import { formatRecordTime } from '@/utils/formatter';
import './index.less';
import CollaborationStore from '@/store/collaboration.store';
import { useEffect, useRef } from 'react';
import Keyframe from '@/sections/Summary/Keyframe';
export interface IProps {
  chapter: IChapterList;
  index: number;
  chapterKeyframes: IKeyframeItem[];
  onVisibleChange?: (visible: boolean) => void;
  handlePreview: (keyframeIndex?: number) => void;
}

const Chapter: React.FC<IProps> = ({ chapter, index, chapterKeyframes, onVisibleChange, handlePreview }) => {
  const showChapterDetail = CollaborationStore((state) => state.showChapterDetail);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const observer = new IntersectionObserver(
        (entries) => {
          onVisibleChange && onVisibleChange(entries[0].isIntersecting);
        },
        {
          threshold: 0.5,
        },
      );
      observer.observe(containerRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [containerRef.current]);

  const displayKeyframes = chapterKeyframes.slice(0, 3);
  const hiddenKeyframesLen = chapterKeyframes.length - displayKeyframes.length;

  return (
    <div key={index} className="flex flex-row" ref={containerRef}>
      <div className="mr-3 flex-shrink-0 flex gap-4 flex-col items-center">
        <div className="size-2 bg-#dbdee4 my-1.6 rounded-full"></div>
        <div className="w-0.25  flex-1 dashed-background"></div>
      </div>
      <div>
        <div className="text-mx-primary text-3 font-500 lh-5 font-number">
          <span>{formatRecordTime(chapter.starttime / 1000)}</span>
          <span className="mx-0.5">-</span>
          <span>{formatRecordTime(chapter.endtime / 1000)}</span>
        </div>
        <div className="text-#30343c text-3.75 font-500 mb-2 mt-2.5 lh-5.5">{chapter.topic}</div>
        {showChapterDetail && <div className="text-#30343C mt-2.5 lh-6 text-3.5">{chapter.summary}</div>}
        <Keyframe index={index} displayKeyframes={displayKeyframes} hiddenKeyframesLen={hiddenKeyframesLen} handlePreview={handlePreview} />
        {(showChapterDetail || displayKeyframes.length > 0) &&<div className='h-4'></div>}
      </div>
    </div>
  );
};

export default Chapter;
